import { AsyncClient } from '@bancolombia/chanjs-client';
import { MINUTES_CONVERTER_TIMEOUT, SECONDS_SOCKET_HEARBEAT } from 'src/shared/Constants/Constants';

let client = null;

export const initAsyncClient = async (socketUrl, channelRef, channelSecret) => {
  if (!client) {
    client = new AsyncClient({
      socket_url: socketUrl,
      channel_ref: channelRef,
      channel_secret: channelSecret,
      heartbeat_interval: MINUTES_CONVERTER_TIMEOUT * SECONDS_SOCKET_HEARBEAT, // 10 seconds
      dedupCacheDisable: true
    });
    client.connect();
  }
};

export const onEvent = (eventPattern, callback) => {
  if (!client) {
    return;
  }

  client.listenEvent(eventPattern, message => {
    callback(message.payload);
  });
};

export const closeClient = () => {
  if (client?.close) {
    client.close();
    client = null;
  }
};
